export const API = "https://api.myatscore.com";

export const PLANS = [
  { id: "single",  name: "Single",  inr: 299,  credits: 1,  tag: null,           desc: "Try it once",                  color: "#6d28d9", perAnalysisInr: 299 },
  { id: "starter", name: "Starter", inr: 999,  credits: 5,  tag: "Most Popular", desc: "Active job search",            color: "#4f46e5", perAnalysisInr: 200 },
  { id: "power",   name: "Power",   inr: 2999, credits: 20, tag: "Best Value",   desc: "Career coaches & power users", color: "#0891b2", perAnalysisInr: 150 },
];

export const CURRENCIES = [
  { code: "INR", symbol: "₹",   name: "Indian Rupee" },
  { code: "USD", symbol: "$",   name: "US Dollar" },
  { code: "GBP", symbol: "£",   name: "British Pound" },
  { code: "EUR", symbol: "€",   name: "Euro" },
  { code: "AED", symbol: "د.إ", name: "UAE Dirham" },
  { code: "SGD", symbol: "S$",  name: "Singapore Dollar" },
  { code: "AUD", symbol: "A$",  name: "Australian Dollar" },
  { code: "CAD", symbol: "C$",  name: "Canadian Dollar" },
  { code: "QAR", symbol: "﷼", name: "Qatari Riyal" },
  { code: "SAR", symbol: "﷼", name: "Saudi Riyal" },
];

export const ISD_CODES = [
  { code: "+91",  flag: "IN", country: "India" },
  { code: "+1",   flag: "US", country: "USA / Canada" },
  { code: "+44",  flag: "GB", country: "UK" },
  { code: "+971", flag: "AE", country: "UAE" },
  { code: "+65",  flag: "SG", country: "Singapore" },
  { code: "+61",  flag: "AU", country: "Australia" },
  { code: "+49",  flag: "DE", country: "Germany" },
  { code: "+33",  flag: "FR", country: "France" },
  { code: "+60",  flag: "MY", country: "Malaysia" },
  { code: "+966", flag: "SA", country: "Saudi Arabia" },
  { code: "+974", flag: "QA", country: "Qatar" },
  { code: "+64",  flag: "NZ", country: "New Zealand" },
  { code: "+27",  flag: "ZA", country: "South Africa" },
  { code: "+92",  flag: "PK", country: "Pakistan" },
  { code: "+880", flag: "BD", country: "Bangladesh" },
  { code: "+94",  flag: "LK", country: "Sri Lanka" },
  { code: "+977", flag: "NP", country: "Nepal" },
];

export const PRIVACY = `**Privacy Policy — MyATScore**
*Last updated: May 2026*

**1. Information We Collect**
When you use MyATScore, we collect:
- **Resume & Job Data:** The resume text and job description text you paste into the tool for analysis.
- **Email Address:** Collected when you purchase a credit pack or use social login, to deliver your activation code and manage your account.
- **Social Profile Info:** If you use Google login, we receive your email address and basic profile information (name) to authenticate your account.

We do not store your resume or job description text after your session ends.

**2. How We Use Your Information**
Your resume and job description text is sent to a third-party AI processing service solely to generate your ATS score and analysis. Your email address and profile info are used to deliver your activation code, authenticate your login, and provide support. We do not sell, rent, or share your personal information with third parties for marketing purposes.

**3. Data Storage**
We do not permanently store the content of your resume or job descriptions. Email addresses and basic profile data are retained to maintain your account, credit balance, and provide customer support.

**4. Cookies**
MyATScore does not use tracking cookies. We may use session storage and essential cookies to maintain your login state and analysis session.

**5. Third-Party Services**
We use third-party services for payment processing (Razorpay/CCAvenue), social authentication (Google), and AI analysis. These services have their own privacy policies.

**6. Social Logins**
When you log in via Google, you authorize us to access your basic profile information. You can revoke this access at any time through your Google account security settings.

**7. Your Rights**
You may request deletion of your account and personal data from our records at any time by contacting us at support@myatscore.com.

**8. Contact**
For privacy-related queries, contact us at: support@myatscore.com`;

export const TERMS = `**Terms of Service — MyATScore**
*Last updated: May 2026*

**1. Acceptance of Terms**
By accessing or using MyATScore ("the Service"), you agree to be bound by these Terms of Service. If you do not agree, please do not use the Service.

**2. Description of Service**
MyATScore provides ATS (Applicant Tracking System) resume analysis and scoring. The Service uses automated analysis to compare your resume against a provided job description and generate a compatibility score, keyword analysis, and improvement suggestions.

**3. Account Creation & Social Login**
You may access the Service by purchasing credits or logging in via Google. You are responsible for maintaining the security of your account and any credentials provided to you. We are not liable for any loss or damage from your failure to protect your login information.

**4. Credit-Based Access**
Access to the Service requires the purchase of credits. Credits are non-transferable and linked to the activation code or social account used at the time of purchase. Each analysis consumes one credit.

**5. Credit Expiry Policy**
Credits are valid for use as long as the account remains active. An account is considered inactive if no credits have been used for a continuous period of 12 months. Upon 12 months of inactivity, any remaining unused credits will expire and will not be recoverable.

To prevent expiry, simply use at least one credit within any 12-month period — this resets the inactivity clock. We will send a reminder email to your registered address 30 days before your credits are due to expire due to inactivity.

Credits consumed in a successful analysis are non-refundable regardless of expiry status.

**6. Service Discontinuation**
In the event that MyATScore discontinues or permanently shuts down the Service, we will provide a minimum of 60 days' advance notice via email to all users with active unused credits. During this notice period, users may either use their remaining credits or request a pro-rata refund for unused credits.

**7. Acceptable Use**
You agree to use the Service only for lawful purposes. You must not use the Service to process content that is illegal, offensive, or violates the rights of others. You must not attempt to reverse-engineer, scrape, or abuse the Service.

**8. Accuracy Disclaimer**
MyATScore provides analysis based on automated processing. Results are intended as guidance only and do not guarantee employment outcomes. We make no warranties about the accuracy or completeness of analysis results.

**9. Intellectual Property**
The MyATScore platform, design, and underlying technology are the intellectual property of MyATScore. The content you submit (resume, job description) remains your own property.

**10. Limitation of Liability**
To the maximum extent permitted by law, MyATScore shall not be liable for any indirect, incidental, or consequential damages arising from your use of the Service.

**11. Changes to Terms**
We reserve the right to modify these Terms at any time. Continued use of the Service after changes constitutes acceptance of the revised Terms.

**12. Prohibited Use**
MyATScore does not sell physical goods, financial instruments, adult content, or any products prohibited under Indian law or applicable payment gateway guidelines. The Service is solely for resume analysis purposes.

**13. Governing Law**
These Terms are governed by the laws of India. Any disputes shall be subject to the jurisdiction of courts in Hyderabad, Telangana.

**14. Contact**
For terms-related queries: support@myatscore.com`;

export const REFUND = `**Refund Policy — MyATScore**
*Last updated: May 2026*

**1. Digital Service — No Refund After Delivery**
MyATScore provides a digital service. Once a resume analysis has been performed (i.e., a credit has been consumed and results have been displayed), that credit is considered delivered and is non-refundable.

**2. Unused Credits**
If you have purchased a credit pack and have not yet used any credits, you may request a refund within 7 days of purchase by contacting us at support@myatscore.com. Refunds for unused credits will be processed within 5–7 business days to your original payment method.

**3. Credit Expiry — Inactivity**
Credits expire after 12 consecutive months of inactivity (no credit usage). A reminder email will be sent 30 days before expiry. Expired credits due to inactivity are non-refundable, as this policy is clearly communicated at the time of purchase and via reminder email.

**4. Technical Failures**
If a credit was consumed due to a technical error on our part (e.g., the analysis failed to return results), we will restore the credit to your account or provide a full refund for that credit upon verification.

**5. Activation Code Issues**
If you did not receive your activation code after payment, please contact us at support@myatscore.com within 48 hours of purchase. We will resend your code or issue a full refund.

**6. How to Request a Refund**
Email us at support@myatscore.com with your registered email address, date of purchase, amount paid, and reason for refund request. We aim to respond to all refund requests within 2 business days.

**7. Transaction Disputes**
Transaction disputes or payment discrepancies must be raised within 7 days of the purchase date by emailing support@myatscore.com. We aim to acknowledge all disputes within 48 hours and resolve them within 7 business days.

**8. Contact**
support@myatscore.com`;

export const ABOUT = `**About MyATScore**

**What We Do**
MyATScore is an AI-powered resume optimization tool that helps job seekers understand why their resumes get filtered out by ATS (Applicant Tracking System) software — and how to fix it.

**The Problem We Solve**
75% of resumes are rejected by automated screening software before a human recruiter ever sees them. Most job seekers don't know this is happening or why. MyATScore gives you a clear compatibility score, identifies missing keywords, and provides actionable fixes in under 15 seconds.

**How It Works**
Paste your resume and any job description into MyATScore. Our AI analyzes your resume against the job description using the same logic as ATS systems like Workday, Greenhouse, Taleo, Lever, and Naukri — keyword matching, format scoring, and skill gap analysis. You get a score from 0-100 along with specific, actionable improvements.

**Why MyATScore**
Unlike general AI assistants, MyATScore is purpose-built for resume optimization. It understands recruiter expectations, ATS parsing logic, and delivers structured, actionable results — not a wall of text. Every analysis includes matched keywords, missing keywords, critical fixes, and an AI-rewritten professional summary tailored to the job description.

**Our Model**
We operate on a simple credit-based model — pay only for what you use. No monthly subscriptions, no hidden fees. Credits are valid as long as you use the service at least once every 12 months. Choose from Single (₹299), Starter (₹999), or Power (₹2,999) plans.

**Contact**
For any queries, reach us at support@myatscore.com. We aim to respond within 2 business days.`;

export const CONTACT = `**Contact Us**

**MyATScore Support**

We're here to help with any questions about your account, credits, or analysis results.

**Email Support**
support@myatscore.com

We respond to all queries within 2 business days. For urgent payment-related issues, please include your order ID and payment date in your email.

**Common Queries**

**I didn't receive my activation code**
Check your spam/junk folder first. If not found, email us at support@myatscore.com with your payment date and amount. We'll resend your code within a few hours.

**My activation code isn't working**
Make sure you're entering both the activation code (ATS-XXXX-XXXX format) and the access key exactly as received in your email. Both are case-sensitive.

**I want a refund**
Please see our Refund Policy for details. Email support@myatscore.com with your order details and reason for refund.

**Technical issues with analysis**
If an analysis fails and consumes a credit, email us immediately at support@myatscore.com. We will restore your credit upon verification.

**Business Hours**
Monday to Saturday, 10:00 AM to 6:00 PM IST

**Response Time**
We aim to respond to all emails within 2 business days.`;

export const SHIPPING = `**Delivery & Shipping Policy**

*Last updated: May 2026*

**Digital Service — Instant Delivery**
MyATScore is a 100% digital service. We do not sell, ship, or deliver any physical goods. There is no shipping involved in any transaction on this platform.

**How Service Is Delivered**
Upon successful payment, your activation code and access key are delivered to your registered email address automatically and instantly. You can then use these credentials on myatscore.com to access your resume analysis credits.

**Delivery Timeline**
- Activation code email: Delivered within 5 minutes of successful payment
- Analysis results: Delivered on-screen within 15 seconds of submission
- Results email: Sent to your registered email address automatically after each analysis

**Non-Delivery**
If you do not receive your activation code within 30 minutes of payment:
1. Check your spam/junk folder
2. Use the "Restore my credits" option on our website
3. Email support@myatscore.com with your payment details

**No Physical Shipping**
As a digital service, there are no shipping charges, no delivery addresses required, and no physical products dispatched. Our service is accessible globally from any device with an internet connection.

**Service Availability**
MyATScore is available 24/7. Occasional maintenance windows may temporarily affect availability. We will notify users of planned downtime via email where possible.

**Contact**
For any delivery-related queries: support@myatscore.com`;

export const FAQ = `**Frequently Asked Questions (FAQ)**

**1. General Questions**

**What is MyATScore?**
MyATScore is an AI-powered resume optimization tool that helps job seekers understand how Applicant Tracking Systems (ATS) see their resumes. We provide a calibrated score, keyword analysis, and actionable fixes to help you get more interviews.

**Is this just another AI chatbot?**
No. While we use AI, MyATScore is specifically built for resume analysis. We score your resume across 5 specific dimensions: Keyword Match, Experience Relevance, Section Completeness, ATS Formatting, and Language Impact. We also provide structural checks and specific bullet point rewrites that general chatbots often miss.

**2. Credits and Pricing**

**How does the credit system work?**
We use a pay-per-use model. 1 analysis consumes 1 credit. You can buy credits in packs: Single (1 credit), Starter (5 credits), or Power (20 credits). There are no monthly subscriptions.

**Do credits expire?**
Credits are valid as long as your account remains active. An account is considered inactive if no credits have been used for 12 consecutive months. We send a reminder 30 days before expiry.

**Can I get a refund for unused credits?**
Yes, you can request a refund for completely unused credit packs within 7 days of purchase. Once a credit is consumed for an analysis, it is non-refundable.

**3. Usage and Results**

**How long does an analysis take?**
Typically under 15 seconds. You'll get your full report on-screen instantly, and we also email a copy to you.

**How accurate is the ATS score?**
Our scoring logic is modeled after major ATS systems like Workday, Taleo, Greenhouse, and Lever. While no tool can guarantee an interview, a higher score on MyATScore significantly improves your chances of passing automated filters.

**Can I save my results?**
Yes! You can download your analysis as a PDF or access it via the email we send you after every analysis.

**4. Privacy and Security**

**Is my resume data stored?**
We do not store your resume or job description text after your session ends. Your data is processed solely to generate your analysis.

**Do you share my data with recruiters?**
No. Your data is private and belongs to you. We do not sell or share your personal information with third parties for marketing or recruitment purposes.

**5. Support**

**I didn't receive my activation code.**
Please check your spam/junk folder. If it's not there, email us at support@myatscore.com with your payment details, and we'll resend it within a few hours.

**My analysis failed but a credit was taken.**
If a technical error occurs, please contact us at support@myatscore.com. We will verify the failure and restore your credit immediately.`;
